"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResolver = void 0;
const createResolver = (schemaComponents) => (schemaType) => schemaComponents[schemaType];
exports.createResolver = createResolver;
